import { Component, Input } from '@angular/core';
import { OrderPreviewData } from '../../order-preview.component';
import { ModalController } from '@ionic/angular';
import { Order } from 'src/app/core/models/order';
import { PaymentMethod } from 'src/app/core/models/order';
import { EndDeliveryComponent } from '../../../end-delivery/end-delivery.component';
import { AnimationOptions } from 'ngx-lottie';
import { VivaWalletPaymentService } from 'src/app/core/services/vivawalet-payment.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent {
  @Input({ required: true }) data!: OrderPreviewData;

  readonly PaymentMethod: typeof PaymentMethod = PaymentMethod;

  paymentMethod: PaymentMethod = PaymentMethod.QrCode;
  options: AnimationOptions = {
    path: '/assets/animation/checkmark.json',
    loop: false
  };

  constructor(
    private modalController: ModalController,
    public vivaWalletPaymentService: VivaWalletPaymentService,
  ) {

  }

  segmentChanged($event: any): void {
    this.paymentMethod = $event.detail.value;
  }

  async endDelivery(order: Order): Promise<void> {
    const modal = await this.modalController.create({
      component: EndDeliveryComponent,
      cssClass: 'end-delivery-modal-css',
      id: 'end-delivery',
      componentProps: {
        order: order
      }
    });
    await modal.present();
  }
}
